firebird.controller('meetingAssistantCtrl', [
    'meetingAssistantService',
    function (meetingAssistantService) {
        var self = this;

        self.isPanelOpen = false;
        self.question = '';

        self.isSupported = function () {
            return meetingAssistantService.isSpeechCaptureSupported();
        };

        self.togglePanel = function () {
            self.isPanelOpen = !self.isPanelOpen;
        };

        self.isCapturing = function () {
            return meetingAssistantService.getIsCapturing();
        };

        self.toggleCapture = function () {
            meetingAssistantService.toggleCapture();
        };

        self.isWaiting = function () {
            return meetingAssistantService.getIsWaitingForAnswer();
        };

        self.getAnswers = function () {
            return meetingAssistantService.getAnswers();
        };

        self.catchMeUp = function () {
            meetingAssistantService.catchMeUp();
        };

        self.ask = function () {
            var question = (self.question || '').trim();
            if (!question) {
                return;
            }
            meetingAssistantService.askQuestion(question);
            self.question = '';
        };
    }
]);
